module.exports = __webpack_public_path__ + "static/altus-logo-5252893691c35f873c8acd8643ad2cab.png";